/* Mock Data for Products and Blog */

export interface Product {
  id: string
  name: string
  price: number
  category: 'Camisetas' | 'Canecas' | 'Moletons'
  image: string
  description: string
  rating: number
  reviews: number
  tags: string[]
}

export interface BlogPost {
  id: string
  title: string
  excerpt: string
  category: string
  date: string
  image: string
  content: string
}

export const products: Product[] = [
  // New DP6 Collection
  {
    id: 'dp6-001',
    name: 'Moletom Pipeline',
    price: 149.9,
    category: 'Moletons',
    image:
      'https://img.usecurling.com/p/500/500?q=black%20sweatshirt%20fish%20pipeline%20graphic&color=black',
    description:
      'Estampa exclusiva "um olho no peixe, outro no pipeline". Conforto e estilo para quem vive no fluxo de dados. Logo dp6 em destaque.',
    rating: 5.0,
    reviews: 12,
    tags: ['Pipeline', 'Data Engineering', 'dp6', 'Inverno'],
  },
  {
    id: 'dp6-002',
    name: 'Camiseta Conversion King',
    price: 89.9,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=grey%20t-shirt%20crown%20graphic&color=gray',
    description:
      'A coroa da conversão. Estampa "conversion KING." com o logo dp6. Para quem domina as métricas e otimização.',
    rating: 4.9,
    reviews: 8,
    tags: ['CRO', 'Marketing', 'dp6', 'King'],
  },
  {
    id: 'dp6-003',
    name: 'Camiseta Data Science Definition',
    price: 89.9,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=white%20t-shirt%20dictionary%20text&color=white',
    description:
      'A definição definitiva: "Sherlock Holmes moderno, mas com queries, gráficos e pouca vida social." Ciência de dados explicada.',
    rating: 5.0,
    reviews: 15,
    tags: ['Data Science', 'Humor', 'dp6', 'Definition'],
  },
  // Existing Camisetas
  {
    id: 'ts-001',
    name: 'Camiseta SQL Injection',
    price: 89.9,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=t-shirt%20hacker%20code&color=black',
    description: 'Proteja seus dados com estilo. 100% Algodão.',
    rating: 4.8,
    reviews: 124,
    tags: ['SQL', 'Security', 'Dev'],
  },
  {
    id: 'ts-002',
    name: 'Camiseta Python Lover',
    price: 79.9,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=t-shirt%20snake%20python&color=blue',
    description: 'Simples é melhor que complexo.',
    rating: 4.9,
    reviews: 89,
    tags: ['Python', 'Code', 'Data Science'],
  },
  {
    id: 'ts-003',
    name: 'Camiseta Data Lake',
    price: 85.0,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=t-shirt%20lake%20water%20data&color=cyan',
    description: 'Mergulhe fundo nos seus dados.',
    rating: 4.5,
    reviews: 32,
    tags: ['Data Lake', 'Big Data'],
  },
  {
    id: 'ts-004',
    name: 'Camiseta Git Push Force',
    price: 92.5,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=t-shirt%20explosion%20danger&color=red',
    description: 'Para quem gosta de viver perigosamente.',
    rating: 5.0,
    reviews: 210,
    tags: ['Git', 'DevOps'],
  },
  {
    id: 'ts-005',
    name: 'Camiseta Kubernetes Captain',
    price: 99.9,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=t-shirt%20ship%20wheel%20container&color=blue',
    description: 'Orquestre seu estilo.',
    rating: 4.7,
    reviews: 56,
    tags: ['K8s', 'DevOps'],
  },
  {
    id: 'ts-006',
    name: 'Camiseta Null Pointer',
    price: 69.9,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=t-shirt%20void%20error&color=gray',
    description: 'O erro de um bilhão de dólares, agora em tecido.',
    rating: 4.2,
    reviews: 15,
    tags: ['Java', 'Bug'],
  },
  {
    id: 'ts-007',
    name: 'Camiseta Cloud Native',
    price: 89.9,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=t-shirt%20cloud%20sky&color=white',
    description: 'Leve e escalável, como sua infra.',
    rating: 4.6,
    reviews: 44,
    tags: ['Cloud', 'AWS', 'Azure'],
  },
  {
    id: 'ts-008',
    name: 'Camiseta Machine Learning',
    price: 95.0,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=t-shirt%20robot%20brain&color=purple',
    description: 'Treinada para ser confortável.',
    rating: 4.9,
    reviews: 102,
    tags: ['AI', 'ML'],
  },
  {
    id: 'ts-009',
    name: 'Camiseta 404 Not Found',
    price: 75.0,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=t-shirt%20missing%20puzzle&color=orange',
    description: 'A camiseta que você estava procurando.',
    rating: 4.4,
    reviews: 28,
    tags: ['Web', 'HTTP'],
  },
  {
    id: 'ts-010',
    name: 'Camiseta Full Stack',
    price: 88.0,
    category: 'Camisetas',
    image:
      'https://img.usecurling.com/p/500/500?q=t-shirt%20layers%20cake&color=green',
    description: 'Frontend no peito, Backend nas costas.',
    rating: 4.8,
    reviews: 77,
    tags: ['Full Stack', 'Dev'],
  },
  // Canecas (8)
  {
    id: 'mg-001',
    name: 'Caneca Java Fuel',
    price: 45.9,
    category: 'Canecas',
    image:
      'https://img.usecurling.com/p/500/500?q=mug%20coffee%20java&color=red',
    description: 'Converta café em código.',
    rating: 4.7,
    reviews: 150,
    tags: ['Java', 'Coffee'],
  },
  {
    id: 'mg-002',
    name: 'Caneca CSS is Awesome',
    price: 42.0,
    category: 'Canecas',
    image:
      'https://img.usecurling.com/p/500/500?q=mug%20messy%20design&color=yellow',
    description: 'Texto fora da caixa (literalmente).',
    rating: 4.9,
    reviews: 200,
    tags: ['CSS', 'Frontend'],
  },
  {
    id: 'mg-003',
    name: 'Caneca Tears of my Stakeholders',
    price: 55.0,
    category: 'Canecas',
    image:
      'https://img.usecurling.com/p/500/500?q=mug%20drops%20water&color=blue',
    description: 'Beba com satisfação.',
    rating: 4.6,
    reviews: 88,
    tags: ['PM', 'Agile'],
  },
  {
    id: 'mg-004',
    name: 'Caneca Linux Root',
    price: 48.9,
    category: 'Canecas',
    image: 'https://img.usecurling.com/p/500/500?q=mug%20penguin&color=black',
    description: 'Você tem permissão para beber.',
    rating: 5.0,
    reviews: 120,
    tags: ['Linux', 'SysAdmin'],
  },
  {
    id: 'mg-005',
    name: 'Caneca Docker Container',
    price: 49.9,
    category: 'Canecas',
    image:
      'https://img.usecurling.com/p/500/500?q=mug%20whale%20container&color=blue',
    description: 'Funciona na minha máquina.',
    rating: 4.8,
    reviews: 95,
    tags: ['Docker', 'DevOps'],
  },
  {
    id: 'mg-006',
    name: 'Caneca Git Blame',
    price: 44.5,
    category: 'Canecas',
    image:
      'https://img.usecurling.com/p/500/500?q=mug%20finger%20pointing&color=orange',
    description: 'Não fui eu.',
    rating: 4.3,
    reviews: 40,
    tags: ['Git', 'Team'],
  },
  {
    id: 'mg-007',
    name: 'Caneca API REST',
    price: 46.0,
    category: 'Canecas',
    image:
      'https://img.usecurling.com/p/500/500?q=mug%20connection%20plug&color=green',
    description: '200 OK.',
    rating: 4.7,
    reviews: 67,
    tags: ['API', 'Backend'],
  },
  {
    id: 'mg-008',
    name: 'Caneca Debugger',
    price: 52.0,
    category: 'Canecas',
    image:
      'https://img.usecurling.com/p/500/500?q=mug%20magnifying%20glass&color=gray',
    description: 'A ferramenta mais importante.',
    rating: 4.9,
    reviews: 112,
    tags: ['Debug', 'Code'],
  },
]

export const blogPosts: BlogPost[] = [
  {
    id: 'blog-001',
    title: 'Como Implementar o GA4 em E-commerce',
    excerpt:
      'Um guia completo sobre eventos de e-commerce no Google Analytics 4.',
    category: 'Tracking',
    date: '2023-10-15',
    image:
      'https://img.usecurling.com/p/600/300?q=analytics%20chart&color=blue',
    content: 'Lorem ipsum dolor sit amet...',
  },
  {
    id: 'blog-002',
    title: 'O Futuro do Server-Side Tagging',
    excerpt: 'Por que o Google Tag Gateway é a próxima grande novidade.',
    category: 'Engenharia de Dados',
    date: '2023-11-02',
    image: 'https://img.usecurling.com/p/600/300?q=server%20rack&color=black',
    content: 'Lorem ipsum dolor sit amet...',
  },
  {
    id: 'blog-003',
    title: 'DataLayer: Boas Práticas',
    excerpt:
      'Mantenha seus dados organizados e limpos para evitar dores de cabeça.',
    category: 'Tracking',
    date: '2023-11-20',
    image:
      'https://img.usecurling.com/p/600/300?q=code%20structure&color=green',
    content: 'Lorem ipsum dolor sit amet...',
  },
  {
    id: 'blog-004',
    title: 'SQL para Analistas de Marketing',
    excerpt: 'Consultas essenciais para extrair insights do BigQuery.',
    category: 'Engenharia de Dados',
    date: '2023-12-05',
    image:
      'https://img.usecurling.com/p/600/300?q=database%20query&color=orange',
    content: 'Lorem ipsum dolor sit amet...',
  },
]
